import { memo } from 'react';
import styled from '@emotion/styled';

import { themeFont } from '../../lib/themeFont';

import type { Wws_HeadlineItem } from '../../types/graphql';

export const H3 = styled("h3")`
  margin: 44px 0 0 0;
  text-align: center;
  word-break: break-word;

  ${themeFont('s3')}
  @media (min-width: 768px) {
    text-align: center;

    .verticalLayout.homePage & {
      text-align: left;
    }
  }
  @media (max-width: 767px) {
    padding: 0 16px;
  }
`;

export const H4 = styled("h4")`
  margin: 24px 0 0 0;
  text-align: center;
  word-break: break-word;

  ${themeFont('s4')}
  @media (min-width: 768px) {
    text-align: center;

    .verticalLayout.homePage & {
      text-align: left;
    }
  }
  @media (max-width: 767px) {
    padding: 0 16px;
  }
`;

export interface HeadlineItemProps {
  item: Wws_HeadlineItem;
  className?: string | undefined;
}

function HeadlineItem({
  className = '',
  item,
}: HeadlineItemProps) {
  const { title, style = 'large', id } = item;

  let Component;

  if (style === 'large') {
    Component = H3;
  } else {
    Component = H4;
  }

  return (
    <Component className={className} data-testid={`headline-item-${id}`}>
      {title}
    </Component>
  );
}

export default memo(HeadlineItem);
